<template>
  <v-card outlined>
    <v-card-title>
      Sales by Rate
    </v-card-title>
    <v-divider class='mx-4'/>
    <v-card-text>
      <im-doughnut-chart :chart-data='chart_data' :options='chart_options' :height='250'/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-doughnut-chart': () => import('@/components/Statistics/DoughnutChart')
    },

    props: {
      sales: Object,
      rates: Array
    },

    computed: {

      chart_data() {
        return {
          labels: this.getChartLabels(),
          datasets: [
            {
              data: this.getChartData(),
              outlineColor: ['#0080ff', '#00ff80', '#ff8000', '#FF9800', '#8000ff'],
              backgroundColor: ['#0080ff', '#00ff80', '#ff8000', '#FF9800', '#8000ff'],
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          tooltips: {
            mode: 'index'
          },
          legend: false,
        }
      }

    },

    methods: {
      getChartLabels() {
        let labels = [];
        if (!this.sales.datasets.rates)
          return labels;

        for (let rate in this.sales.datasets.rates) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rates, rate))
            labels.push(this.rates[rate].text);
        }

        return labels;
      },

      getChartData() {
        let data = [];
        if (!this.sales.datasets.rates)
          return data;

        for (let rate in this.sales.datasets.rates) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rates, rate))
            data.push(_.sum(this.sales.datasets.rates[rate].sales));
        }

        return data;
      }
    }

  }
</script>